import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import Button from "@vfuk/core-button/dist/Button";
import { Grid, GridColumn, GridRow } from "@vfuk/core-grid";
import Heading from "@vfuk/core-heading";
import Image from "@vfuk/core-image";
import ListGroup from "@vfuk/core-list-group";
import ListItem from "@vfuk/core-list-item";
import SimpleGrid from "@vfuk/core-simple-grid";
import Spacing from "@vfuk/core-spacing";

import successTick1x from "../../assets/images/light_theme1x.png";
import successTick2x from "../../assets/images/light_theme2x.png";
import successTick3x from "../../assets/images/light_theme3x.png";
import message1x from "../../assets/images/msg1x.png";
import message2x from "../../assets/images/msg2x.png";
import message3x from "../../assets/images/msg3x.png";

export type SuccessMessageContentProps = {
  heading: string;
  body: string | ReactNode;
  addText?: string;
  confirmText?: string;
  primaryButtonText?: string;
  productListHeader?: string;
  productList?: string[];
  onConfirm: () => void;
  onAdd?: () => void;
  addTextEnable?: boolean;
  secondaryButtonText?: string;
};

const ListItems = styled.div`
  .ListGroupstyle__ListGroup-sc-r71sl4-0 > li {
    display: list-item;
  }
`;

export const SuccessMessageContent = ({
  heading,
  body,
  addText,
  confirmText,
  primaryButtonText,
  productListHeader,
  productList,
  onConfirm,
  onAdd,
  addTextEnable,
  secondaryButtonText,
}: SuccessMessageContentProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <>
      <Grid>
        <GridRow>
          <GridColumn col={1}>
            <Image
              alt={t("shared:users:alt_message")}
              sm={{
                src: successTick1x,
                srcSet: {
                  x1: successTick1x,
                  x2: successTick2x,
                  x3: successTick3x,
                },
              }}
            />
          </GridColumn>
          <GridColumn col={9}>
            <Spacing spacingLevel={{ top: 4, left: 7, right: 7, bottom: 1 }}>
              <Heading level={4} weight={3}>
                {heading}
              </Heading>
            </Spacing>
            <Spacing spacingLevel={{ top: 5, left: 7, right: 7, bottom: 7 }}>
              <div className="modalSubmessage">{body}</div>

              {(primaryButtonText || secondaryButtonText) && (
                <Spacing spacingLevel={{ top: 5 }}>
                  <SimpleGrid spacing={2}>
                    {secondaryButtonText && (
                      <Button
                        width="auto"
                        text={secondaryButtonText}
                        onClick={onAdd}
                        appearance="alt1"
                      />
                    )}
                    {primaryButtonText && (
                      <Button
                        width="auto"
                        text={primaryButtonText}
                        onClick={onConfirm}
                      />
                    )}
                  </SimpleGrid>
                </Spacing>
              )}

              {/* {primaryButtonText && (
                <Spacing spacingLevel={{ top: 5 }}>
                  <Button
                    width="auto"
                    text={primaryButtonText}
                    onClick={onConfirm}
                  />
                </Spacing>
              )} */}
            </Spacing>
            <>
              <Spacing spacingLevel={{ top: 1, left: 7, right: 7, bottom: 7 }}>
                <Heading level={5} weight={3}>
                  {productListHeader || ""}
                </Heading>

                {productList && (
                  <ListItems>
                    <ListGroup listStyle="default" type="unordered">
                      {productList?.map((item, key) => (
                        <ListItem id={`unordered-${key}`} key={key}>
                          {item}
                        </ListItem>
                      ))}
                    </ListGroup>
                  </ListItems>
                )}
              </Spacing>
            </>
          </GridColumn>
          <GridColumn col={2}>
            <Image
              alt={t("shared:users:alt_message")}
              sm={{
                src: message2x,
                srcSet: {
                  x1: message1x,
                  x2: message2x,
                  x3: message3x,
                },
              }}
            />
          </GridColumn>
        </GridRow>
        <GridRow justify="center">
          {addText && (
            <GridColumn col={2}>
              <Button
                width="full"
                text={addText || ""}
                onClick={onAdd}
                appearance="alt1"
                state={addTextEnable ? undefined : "disabled"}
              />
            </GridColumn>
          )}

          {confirmText && (
            <GridColumn col={!addText ? 12 : 2}>
              <Button width="full" text={confirmText} onClick={onConfirm} />
            </GridColumn>
          )}
        </GridRow>
      </Grid>
    </>
  );
};
